var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7169 6.99699L11.717 6.99707L11.7258 6.98793C12.1953 6.50226 12.208 5.72075 11.7169 5.22966C11.2307 4.74344 10.4358 4.74344 9.94959 5.22966L7.05325 8.126L6.05025 7.123C5.56402 6.63677 4.76915 6.63677 4.28292 7.123C3.79669 7.60922 3.79669 8.4041 4.28292 8.89032L6.16959 10.777C6.40197 11.0094 6.71875 11.1433 7.05325 11.1433C7.38776 11.1433 7.70453 11.0094 7.93691 10.777L7.40658 10.2467L7.93691 10.777L11.7169 6.99699ZM2.08325 7.99999C2.08325 4.74087 4.7408 2.08333 7.99992 2.08333C11.259 2.08333 13.9166 4.74087 13.9166 7.99999C13.9166 11.2591 11.259 13.9167 7.99992 13.9167C4.7408 13.9167 2.08325 11.2591 2.08325 7.99999Z",
    fill: "#12B76A",
    stroke: "#12B76A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.1591eae156310c2e4a376d40c5f213a4.svg";
export { ForwardRef as ReactComponent };